(() => {
  const ringSizeInputs = document.querySelectorAll('input[name="ringsize"]');
  const addToCartButton = document.querySelector('#addToBagButton');

  function updateAddToCartButton() {
    const selectedSize = document.querySelector('input[name="ringsize"]:checked');
    const isSizeSelected = selectedSize && selectedSize.value !== 'Select your size';

    if (addToCartButton) {
      const buttonText = addToCartButton.querySelector('.button__text');

      if (isSizeSelected) {
        addToCartButton.disabled = false;
        addToCartButton.style.pointerEvents = 'auto';

        // Restore original text
        if (buttonText && buttonText.dataset.originalText) {
          buttonText.innerHTML = buttonText.dataset.originalText;
        }
      } else {
        addToCartButton.disabled = true;
        addToCartButton.style.pointerEvents = 'none';

        // Change text to "SELECT YOUR SIZE"
        if (buttonText) {
          // Store original text if not already stored
          if (!buttonText.dataset.originalText) {
            buttonText.dataset.originalText = buttonText.innerHTML;
          }

          // Update the text part to "SELECT YOUR SIZE - "
          const textNode = buttonText.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = 'SELECT YOUR SIZE - ';
          } else {
            buttonText.insertBefore(document.createTextNode('SELECT YOUR SIZE - '), buttonText.firstChild);
          }
        }
      }
    }
  }

  // Initial state
  updateAddToCartButton();

  // Update on size selection change
  ringSizeInputs.forEach(input => {
    input.addEventListener('change', updateAddToCartButton);
  });
})();
